import {
  CommonModule,
  Location
} from '@angular/common';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewChecked,
  inject,
  AfterContentChecked
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent,
  WmsSpinnerComponent,
  WMSEditorComponent,
  WmsTreeComponent,
  IWMSStandaloneEditorConstructionOptions,
  WmsSplitPaneComponent,
  WmsSplitPanelComponent
} from '@wms/components';
import {WMSFileUploadComponent} from "./wms-file-upload/wms-file-upload.component";
import {FileService, PrefabService, ThemeService, PageTemplatesService, ConnectorService, TreeService, ProjectService, DialogService,
  NotificationService, RouterHistoryService, SpinnerService, StudioService} from "@wms/services";
import {
  isTextLikeFile,
  isImageFile,
  isDockerFile,
  isZipFile,
  isExeFile,
  isAudioFile,
  isVideoFile,
  isJarFile,
  getProjectResourcePath,
  StateManagerService,
  VersionManagerPipe,
  deleteResourceRestricted
} from "@wms/core";
import {
  WMSResourceDropTargetDirective
} from "./wms-resource-drop-target/wms-resource-drop-target.directive";
import {cloneDeep, flatten, forEach, isEmpty, reverse, uniqBy} from "lodash-es";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { runtimeEventManager } from '@wm/core';
import { WmsWorkspaceManagerService } from "@wms/workspace";
import { WmsFeatureDirective } from "@wms/directives";
import { AppResourceManagerService } from '@wms/design-container';
import { ImportIconsComponent } from "@wms/app/import-icons/import-icons.component";
import { AddCustomIconTemplateComponent } from "@wms/app/add-custom-icon-template/add-custom-icon-template.component";
import { ArtifactsService } from "@wms/settings/artifacts";
import { SecurityService } from '../settings-workspace/security/services/security.service';
import {IntellisenseGeneratorService} from "@wms/app/components/wms-editor/intellisense-generator.service";
import {FileWorkspaceService} from "@wms/app/file-workspace.service";
import {editor, IPosition} from "monaco-editor";
import ITextModel = editor.ITextModel;
import FindMatch = editor.FindMatch;
import {BehaviorSubject, Subscription} from "rxjs";
const readOnlyFiles = ['generated-angular-app', 'ui-build.js', 'profiles/devstudio.properties', 'app.override.css'];

type activeResource = {
  name: string;
  path: string;
  type: any;
  relativePath: string;
  absPath: string;
  allowEdit: boolean;
  allowDelete: boolean;
};

type resource = {
  name: string;
  displayKey: string;
  mimeType: string;
  path: string;
  isActive: boolean;
  successMsg: string;
  errorMsg: string;
  lastSelected: Partial<activeResource> | undefined;
};

type teamProjectObj = {
  teamProjectObject: {
    branchType: string;
  };
};

type helpLink = {
  externalLinks: {
    IMPORT_IMAGE: string;
  };
};

type workspace = {
  editor: {
    readOnly: boolean;
  };
};


enum RESOURCE_TYPES {
  TEXT= "TEXT",
  IMAGE= "IMAGE",
  CANNOT_DISPLAY = "CANNOT_DISPLAY",
  FOLDER = "FOLDER"
};

type uploadMessage = {
  caption: string | null;
  type: string | null;
};

type ctrlScope = {
  showAddFolderOption: boolean;
};

@Component({
  selector: 'wms-file-workspace',
  standalone: true,
  templateUrl: './file-workspace.component.html',
  styleUrls: ['./file-workspace.component.less'],
  imports: [
    CommonModule,
    FormsModule,
    WMSEditorComponent,
    WmsTreeComponent,
    WMSFileUploadComponent,
    WmsDialogHeaderComponent,
    WmsDialogComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsSpinnerComponent,
    WMSResourceDropTargetDirective,
    BsDropdownModule,
    WmsSplitPaneComponent,
    WmsSplitPanelComponent,
    VersionManagerPipe,
    WmsFeatureDirective,
    ReactiveFormsModule,
    AddCustomIconTemplateComponent
  ],
  providers: []
})
export class FileWorkspaceComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewChecked, AfterContentChecked {
  projectResourcesTree: any = [];
  ws: workspace = {
    editor: {
      readOnly: false
    }
  };
  hideResources: boolean = false;
  teamProjectObj: teamProjectObj = {
    teamProjectObject: {
      branchType: ''
    }
  };
  helpLink: helpLink = {
    externalLinks: {
      IMPORT_IMAGE: "https://www.wavemaker.com/learn/app-development/services/3rd-party-libraries/#resource-files"
    }
  };

  FILE_TYPES: any = {
    "html, HTML": "html",
    "css, CSS": "css",
    "js, JS, Javascript, JavaScript, JAVASCRIPT": "javascript",
    "json, Json, JSON": "json",
    "ts,tsx, TS, TypeScript, TYPESCRIPT": "typescript",
    "java, Java, JAVA": "java",
    "md, MD": "markdown",
    "xml, XML": "xml",
    "less, LESS": "less",
    "yml, yaml": "yaml",
  };
  selectedNode: activeResource;

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  dialogTitleKey: string = "LABEL_IMPORT_RESOURCE";
  resources: resource[] = [{
    name: "audio",
    displayKey: "LABEL_AUDIO",
    mimeType: "audio/*",
    path: "resources/audios",
    isActive: false,
    successMsg: "MESSAGE_SUCCESS_AUDIO_IMPORT_DESC",
    errorMsg: "MESSAGE_ERROR_AUDIO_IMPORT_DESC",
    lastSelected: undefined
  }, {
    name: "connectors",
    displayKey: "LABEL_CONNECTOR",
    mimeType: "application/zip",
    path: "WEB-INF/connectors",
    isActive: false,
    successMsg: "MESSAGE_SUCCESS_CONNECTOR_IMPORT_DESC",
    errorMsg: "MESSAGE_ERROR_CONNECTOR_IMPORT_DESC",
    lastSelected: undefined
  }, {
      name: "icons",
      displayKey: "LABEL_ICONS",
      mimeType: " ",
      path: 'resources/icons',
      isActive: false,
      successMsg: "MESSAGE_SUCCESS_ICON_IMPORT_DESC",
      errorMsg: "MESSAGE_ERROR_ICON_IMPORT_DESC",
      lastSelected: undefined

    },{
    name: "image",
    displayKey: "LABEL_IMAGE",
    mimeType: "image/*",
    path: "resources/images/imagelists",
    isActive: false,
    successMsg: "MESSAGE_SUCCESS_IMAGE_IMPORT_DESC",
    errorMsg: "MESSAGE_ERROR_IMAGE_IMPORT_DESC",
    lastSelected: undefined
  }, {
    name: "jar",
    displayKey: "LABEL_FILES_TREE_LIB",
    mimeType: ".jar",
    path: "../lib",
    isActive: false,
    successMsg: "MESSAGE_SUCCESS_JAR_IMPORT_DESC",
    errorMsg: "MESSAGE_ERROR_JAR_IMPORT_DESC",
    lastSelected: undefined
  }, {
    name: "project",
    displayKey: "LABEL_PROJECT",
    mimeType: "",
    path: "../project",
    isActive: true,
    successMsg: "",
    errorMsg: "",
    lastSelected: undefined
  }, {
    name: "resources",
    displayKey: "LABEL_FILES_TREE_RESOURCES",
    mimeType: "",
    path: "./resources",
    isActive: false,
    successMsg: "MESSAGE_SUCCESS_RESOURCE_IMPORT_DESC",
    errorMsg: "MESSAGE_ERROR_RESOURCE_IMPORT_DESC",
    lastSelected: undefined
  }, {
    name: "services",
    displayKey: "LABEL_FILES_TREE_SERVICES",
    mimeType: "",
    path: "../services",
    isActive: false,
    successMsg: "",
    errorMsg: "",
    lastSelected: undefined
  }, {
    name: "video",
    displayKey: "LABEL_VIDEO",
    mimeType: "video/*",
    path: "resources/videos",
    isActive: false,
    successMsg: "MESSAGE_SUCCESS_VIDEO_IMPORT_DESC",
    errorMsg: "MESSAGE_ERROR_VIDEO_IMPORT_DESC",
    lastSelected: undefined
  }, {
    name: "prefabs",
    displayKey: "LABEL_IMPORT_PREFAB",
    mimeType: "application/zip",
    path: "services/import",
    isActive: false,
    successMsg: "MESSAGE_SUCCESS_PREFAB_IMPORT_DESC",
    errorMsg: "MESSAGE_ERROR_PREFAB_IMPORT_DESC",
    lastSelected: undefined
  }, {
    name: "templatebundles",
    displayKey: "LABEL_IMPORT_TEMPLATEBUNDLE",
    mimeType: "application/zip",
    path: "services/import",
    isActive: false,
    successMsg: "MESSAGE_SUCCESS_TEMPLATEBUNDLE_IMPORT_DESC",
    errorMsg: "MESSAGE_ERROR_TEMPLATEBUNDLE_IMPORT_DESC",
    lastSelected: undefined
  }, {
    name: "themes",
    displayKey: "LABEL_IMPORT_THEME",
    mimeType: "application/zip",
    path: "services/themes/import",
    isActive: false,
    successMsg: "MESSAGE_SUCCESS_THEME_IMPORT_DESC",
    errorMsg: "MESSAGE_ERROR_THEME_IMPORT_DESC",
    lastSelected: undefined
  }];
  disableInactiveResources: boolean = false;
  ctrlScope: ctrlScope = {
    showAddFolderOption: false
  }
  uploadMessage: uploadMessage = {
    caption: null,
    type: null
  };
  disableDialogActions: boolean;
  messageClass: string;
  messageIconClass: string;
  newFolderName: string;
  addingFolder: boolean = false;
  dialogProjectResourcesTree: any = [];
  dialogSelectedNode: activeResource;
  dialogActiveResource: activeResource ;
  folder: string;
  resourceView: string;
  activePath: string;
  mimeType: string = "application/zip";
  showDropView: boolean = false;
  showPrefabInfoLink: boolean;

  protected readonly isImageFile = isImageFile;
  protected readonly isTextLikeFile = isTextLikeFile;
  protected readonly isDockerFile = isDockerFile;
  private navigateToResource: any;

  @ViewChild("new_folder_name_input", {static: false}) newFolderInput: ElementRef;
  @ViewChild(WMSFileUploadComponent) wmsFileUpload: WMSFileUploadComponent;
  @ViewChild(WMSEditorComponent) editorComponent: WMSEditorComponent;

  navigateFunctionSubject: BehaviorSubject<string> = new BehaviorSubject("");
  navigateFunctionSubscription: Subscription;
  private saveFileWorkspaceSubscription: Subscription;
  public routerHistoryService: RouterHistoryService;
  private wsManager: WmsWorkspaceManagerService;
  private isInitialized: boolean = false;
  showUploadFont:boolean;
  selectedFiles:any;
  fileName:any;
  showIfNoResource:boolean;
  fileWorkspaceService:FileWorkspaceService;
  constructor(
    private treeService: TreeService,
    private intellisenseGeneratorService: IntellisenseGeneratorService,
    private fileService: FileService,
    private prefabService: PrefabService,
    private themeService: ThemeService,
    private pageTemplatesService: PageTemplatesService,
    private connectorService: ConnectorService,
    private dialogService: DialogService,
    private stateManager: StateManagerService,
    private notificationService: NotificationService,
    private spinnerService: SpinnerService,
    private artifactsService: ArtifactsService,
    private route: ActivatedRoute,
    private studioService: StudioService,
    private router: Router,
    private resourceMngr: AppResourceManagerService,
    private securityService: SecurityService,
    private location: Location) {
    super();
    this.wsManager = inject(WmsWorkspaceManagerService);
    this.routerHistoryService = inject(RouterHistoryService);
    this.fileWorkspaceService = inject(FileWorkspaceService);
    runtimeEventManager.on('loadResource').subscribe((nodeInfo: any) => {
      this.navigateToResource = nodeInfo;
      if (this.isInitialized) {
        this.handleResourceNodeClick(nodeInfo);
        this.navigateToResource = undefined;
      }
    });
    runtimeEventManager.on('navigateToFunction').subscribe(fnName => {
      this.navigateFunctionSubject.next(fnName);
    });
    this.registerDestroyListener.add(runtimeEventManager.on('set-cursor-position').subscribe((data) => {
      this.setCursorPosition(data);
    }));

    this.saveFileWorkspaceSubscription = this.eventManager.saveFileWorkspaceObservable().subscribe((successCallback: Function) => {
      if (this.fileWorkspaceService.resourceModified) {
        this.fileWorkspaceService.save(this.fileWorkspaceService.activeResource.path).then(() => successCallback());
      } else {
        successCallback();
      }
    });
  }

  ngOnInit(): void {
    this.selectedNode = {
      ...this.fileWorkspaceService.activeResource
    };
    this.dialogActiveResource  = {
      ...this.fileWorkspaceService.activeResource
    }
    this.teamProjectObj.teamProjectObject.branchType = this.fileWorkspaceService.project.branchType;
    this.fileWorkspaceService.resourceModified = false;
    this.showIfNoResource = false;
    this.showUploadFont = false;
    this.wsManager.setActiveWSCategory('RESOURCE');
    this.wsManager.setActiveWS({
      type: 'RESOURCE',
      identifier: 'RESOURCE',
      details: {}
    });
    this.isInitialized = true;
    this.location.replaceState('/files' + window.location.search);
    this.stateManager.getWSState();
    this.loadProjectEDNDetails();
    let selectedFileInfo: any = this.route.snapshot.params.hasOwnProperty("path") ? this.route.snapshot.params : undefined;
    this.handleResourceNodeClick(this.navigateToResource || selectedFileInfo || this.getLastActiveResourceFromState());
    if (selectedFileInfo) {
      this.loadProjectResourcesTree(selectedFileInfo["path"]).then(()=>{
        this.handleResourceNodeClick(selectedFileInfo)
      })
    }
    else {
      let lastActiveResourceFromState: activeResource =  this.getLastActiveResourceFromState();
      let defaultPath:any;
      this.loadProjectResourcesTree(lastActiveResourceFromState.path).then(()=>{
        if(lastActiveResourceFromState.path){
          this.handleResourceNodeClick(lastActiveResourceFromState )
        }else {
          defaultPath = { dataItem: this.projectResourcesTree[0].children.find((node: any) => node.id === "README.md")}
          this.handleResourceNodeClick(defaultPath);
        }

      })
    }
    this.navigateToResource = undefined;
    this.wsManager.setFileRef(this);
    this.showPrefabInfoLink = this.preferences.workspace?.user?.prefabEditingEnabled != true && !this.studioService.isSilo;
  }

  ngAfterViewChecked(): void {
    if (this.newFolderInput) {
      this.newFolderInput.nativeElement.focus();
    }
  }

  ngAfterContentChecked(): void {
    if (this.editorComponent && (!this.fileWorkspaceService.editorOptions.theme || !this.fileWorkspaceService.editorOptions.fontSize)) {
      this.fileWorkspaceService.editorOptions.theme = this.editorComponent.options.theme;
      this.fileWorkspaceService.editorOptions.fontSize = this.editorComponent.options.fontSize;
      this.fileWorkspaceService.setEditor(this.editorComponent);
    }
  }

  override ngOnDestroy(): void {
    this.isInitialized = false;
    super.ngOnDestroy();
    if (this.fileWorkspaceService.resourceModified) {
      this.fileWorkspaceService.save(this.fileWorkspaceService.activeResource.path);
    }
    runtimeEventManager.off('navigateToFunction');
    this.navigateFunctionSubscription?.unsubscribe();
    this.saveFileWorkspaceSubscription?.unsubscribe();
  }

  loadProjectEDNDetails(): void {
    this.fileWorkspaceService.project = this.projectService.getProjectEdnDetails();
    this.teamProjectObj.teamProjectObject.branchType = this.fileWorkspaceService.project.branchType;
    this.fileWorkspaceService.project.defaultLanguage = this.projectService.getDetails().properties.defaultLanguage;
  }

  /**
   * Loads the project resource data through API call to file service
   * transform the data into the data that the tree component accepts
   * feed the transformed data to this.projectResourceTree
   */
  loadProjectResourcesTree(path: string): Promise<void> {
    return this.fileService.readDir('../project').then((data: any): void => {
      data.name = data.name || this.fileWorkspaceService.project.name;
      this.projectResourcesTree = this.treeService.transformResourceTreeObject('project', data, false, path);
    });
  }

  /**
   * refresh the project resource tree
   * hard reload the data and re-render
   */
  refreshResources(path: string, callback: any): void {
    this.projectResourcesTree = [];
    this.loadProjectResourcesTree(path, ).then(()=>{
      callback
    })
  }

  loadDialogResourcesTree(path: string, callback: any): void {
    this.fileService.readDir(this.activePath).then((data: any): void => {
      if(data.name === 'icons'){
        this.fileService.storeIconFamiliesList = data.files
      }
      data.name = data.name || (this.resourceView === "project" ? this.fileWorkspaceService.project.name : this.resourceView);
      this.dialogProjectResourcesTree = this.treeService.transformResourceTreeObject(this.resourceView, data,false, path);
      callback;
    }, (error) => {
      if(error.status === 404 && path === 'resources/icons') {
        const data = {
          "name": "icons",
          "type": "folder",
          "path": "resources/icons",
          "files": []
        }
        this.dialogProjectResourcesTree = this.treeService.transformResourceTreeObject(this.resourceView, data,false, path);
      }
    });
  }

  refreshDialogResources(path: string, callback?: any): void {
    this.dialogProjectResourcesTree = [];
    this.loadDialogResourcesTree(path, callback);
  }

  // async save(resourcePath: string): Promise<void> {
  //   await this.editorComponent.triggerFormat();
  //   this.securityService._authInfo =  undefined;
  //   return this.fileService.save(resourcePath, this.editorOptions.value).then((): void => {
  //     // Changes made in the files(html,css,js,variables.json) should be reflected when we route again to page workspace
  //     // so removing the cache.
  //     this.securityService.getAuthInfo();
  //     const pageNamePattern = '[a-zA-Z0-9_-]+';
  //     const fileExtensions = 'html|js|variables\\.json|css';
  //     const patternString = `\\/pages\\/(${pageNamePattern})\\/\\1\\.(${fileExtensions})`;
  //     const pattern = new RegExp(patternString);
  //     const match = resourcePath.match(pattern);
  //     if (match) {
  //       this.resourceMngr.removeUrlCache(match[1]);
  //     }
  //     this.notificationService.show("success", this.locale["MESSAGE_SUCCESS_TITLE"], this.locale["MESSAGE_SUCCESS_SAVE_FILE_DESC"]);
  //     this.resourceModified = false;
  //     this.wsManager.setDirtyonWs(this.resourceModified);
  //     const pathArr = resourcePath.split("/")
  //     if(pathArr.length && pathArr.at(-1) === 'app.variables.json'){
  //         this.eventManager.emitReloadAppVariables()
  //     }
  //     if (pathArr.length && pathArr.includes('overrides')) {
  //       this.eventManager.emitReloadDesignTokens();
  //     }
  //   });
  // }

  getActiveResource(nodeData: any): activeResource {
    if (nodeData.hasOwnProperty("dataItem")) {
      return nodeData.dataItem.props;
    } else {
      return nodeData;
    }
  }

  emptyState(): boolean {
    return this.stateManager.getWSState().length == 0;
  }

  getLastActiveResourceFromState(): activeResource {
    if (this.emptyState()) {
      return {
        name: "", absPath: "", allowDelete: true, allowEdit: true, path: "", relativePath: "", type: undefined,
      };
    }
    let stateArr = this.stateManager.getWSState();
    return {...stateArr[stateArr.length - 1]};
  }

  saveModifiedResource(): void {
    let lastActiveResource: activeResource = this.getLastActiveResourceFromState();
    if (this.fileWorkspaceService.resourceModified && lastActiveResource && (lastActiveResource.type === "file") && (lastActiveResource.path !== this.fileWorkspaceService.activeResource.path)) {
      this.fileWorkspaceService.save(lastActiveResource.path);
    }
  }

  setState(activeResource: any): void {
    let resourceState: any[] = [...this.stateManager.getWSState()];
    for (let j: number = 0; j < resourceState.length; j++) {
      if (resourceState[j].path === activeResource.path) {
        resourceState.splice(j, 1);
      }
    }
    resourceState.push(activeResource);
    this.stateManager.setWSState(resourceState);
  }

  getFileType(fileName: string): string {
    let fileExtension: string | undefined = fileName?.split(".").pop();
    if (!fileExtension) {
      return "plaintext";
    }
    for (let fileExtensions in this.FILE_TYPES) {
      if (this.FILE_TYPES.hasOwnProperty(fileExtensions)) {
        if (fileExtensions.split(",").includes(fileExtension)) {
          return this.FILE_TYPES[fileExtensions];
        }
      }
    }
    return "plaintext";
  }

  handleResourceNodeClick(nodeData: any): void {
    this.fileWorkspaceService.activeResource = this.getActiveResource(nodeData);
    this.fileWorkspaceService.activeResource = {
      ...this.fileWorkspaceService.activeResource,
      absPath: getProjectResourcePath(this.fileWorkspaceService.project.studioProjectId || this.projectService.getProjectId()) + this.fileWorkspaceService.activeResource.path,
      allowEdit: false,
      allowDelete: true,
    }
    this.intellisenseGeneratorService.setIsFileWorkSpace(true);
    this.intellisenseGeneratorService.setActiveResourcePath(this.fileWorkspaceService.activeResource.path);

    if(isTextLikeFile(this.fileWorkspaceService.activeResource.name) || isDockerFile(this.fileWorkspaceService.activeResource.name)) {
      this.fileWorkspaceService.activeResource.allowEdit = true;
    }

    // To hide save and delete buttons for generated angular app and ui-build.js
    if (this.isFileReadOnly(this.fileWorkspaceService.activeResource.relativePath)) {
      this.fileWorkspaceService.activeResource.allowEdit = false;
      this.fileWorkspaceService.activeResource.allowDelete = false;
    }

    this.selectedNode = this.fileWorkspaceService.activeResource;
    if (this.fileWorkspaceService.activeResource.name) {
      this.saveModifiedResource();
      this.setState({...this.fileWorkspaceService.activeResource});
    }
    let type = this.fileWorkspaceService.activeResource.type;
    if (type === "file" || type === this.fileWorkspaceService.RESOURCE_TYPES.TEXT || type === this.fileWorkspaceService.RESOURCE_TYPES.IMAGE) {
      if (isImageFile(this.fileWorkspaceService.activeResource.name)) {
        this.fileWorkspaceService.activeResource.type = this.fileWorkspaceService.RESOURCE_TYPES.IMAGE;
      } else if (isTextLikeFile(this.fileWorkspaceService.activeResource.name) || isDockerFile(this.fileWorkspaceService.activeResource.name)) {
        this.setState(this.fileWorkspaceService.activeResource);
        this.fileWorkspaceService.activeResource.type = this.fileWorkspaceService.RESOURCE_TYPES.TEXT;
        this.fileService.read(this.fileWorkspaceService.activeResource.path).then((data: any): void => {
          this.fileWorkspaceService.editorOptions = {
            ...this.fileWorkspaceService.editorOptions,
            language: this.getFileType(this.fileWorkspaceService.activeResource.name),
            value: data
          }
          if(!this.navigateFunctionSubject.observed) {
            this.navigateFunctionSubscription = this.navigateFunctionSubject.asObservable().subscribe((fnName)=> {
              this.navigateToFunction(fnName);
            });
          }
        });
      } else {
        this.fileWorkspaceService.activeResource.type = this.fileWorkspaceService.RESOURCE_TYPES.CANNOT_DISPLAY;
      }
      this.wsManager.setActiveWS({...this.fileWorkspaceService.activeResource, ...{_category: 'RESOURCE'}});
    } else if (this.fileWorkspaceService.activeResource.type === "folder") {
      this.fileWorkspaceService.activeResource.type = this.fileWorkspaceService.RESOURCE_TYPES.FOLDER;
      this.setState(this.fileWorkspaceService.activeResource);
      this.wsManager.setActiveWS({...this.fileWorkspaceService.activeResource, ...{_category: 'RESOURCE'}});
    }
    this.handleReadonlyForWSFile(this.fileWorkspaceService.activeResource.relativePath);
  }

  removeLastActiveResourceFromState(): void {
    if (this.emptyState())
      return;
    let stateArr = this.stateManager.getWSState();
    stateArr.pop();
    this.stateManager.setWSState(stateArr);
  }
  removeResourcesFromState(dialogSelectedNodePath: string): void {
    let stateArr = this.stateManager.getWSState();
    for (let n=0; n<stateArr.length; n++) {
      if (stateArr[n].path?.startsWith(dialogSelectedNodePath)) {
        stateArr.splice(n,  1);
      }
    }
    this.stateManager.setWSState(stateArr);
  }


  remove(): void {
    this.closeDialogWithId('deleteResourceModal');
    this.fileService.remove(this.fileWorkspaceService.activeResource.path).then((data): void => {
      this.notificationService.show("success", this.locale["MESSAGE_SUCCESS_TITLE"], this.locale["MESSAGE_SUCCESS_DELETE_FILE_DESC"]);
      this.fileWorkspaceService.resourceModified = false;
      this.wsManager.setDirtyonWs(this.fileWorkspaceService.resourceModified);
      this.removeLastActiveResourceFromState();
      let lastActiveResource: activeResource = this.getLastActiveResourceFromState();
      this.refreshResources(lastActiveResource.path, this.handleResourceNodeClick(lastActiveResource));
    });
  }

  updateEditorOptions(options: IWMSStandaloneEditorConstructionOptions): void {
    this.fileWorkspaceService.editorOptions.value = options.value;
    this.fileWorkspaceService.resourceModified = true;
    this.wsManager.setDirtyonWs(this.fileWorkspaceService.resourceModified);
  }

  openDialogWithId(id: string): void {
    this.dialogService.open(id);
  }

  closeDialogWithId(id: string): void {
    this.dialogService.close(id);
    if(id === 'uploadGenericResourcesDialog') {
      this.setUploadMessage(null, null);
    }
  }

  toggleToolsPanelDisplay(): void {
    this.hideResources = !this.hideResources;
     $(".workspace-header").toggleClass("width_100");
  }


  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  getTreeNode(node: any): activeResource {
    if (node.hasOwnProperty("dataItem")) {
      return node.dataItem.props;
    } else {
      return node;
    }
  }

  getActiveDialogResource(): resource | undefined {
    for (let resource of this.resources) {
      if (resource.isActive) {
        return resource;
      }
    }
    return undefined;
  }

  setLastSelected(node: any): void {
    let resource: resource | undefined = this.getActiveDialogResource();
    if (resource) {
      resource.lastSelected = node;
    }
  }

  setDialogActiveResource(node: any): void {
    this.dialogActiveResource = node;
  }

  setFolder(node: any): void {
    if (node.type === "folder" || node.type === RESOURCE_TYPES.FOLDER) {
      this.folder = node.path;
    } else if (node.type === "file" || node.type === RESOURCE_TYPES.TEXT ||  node.type === RESOURCE_TYPES.IMAGE || node.type === RESOURCE_TYPES.CANNOT_DISPLAY) {
      let folderPath = node.path.split("/");
      folderPath.pop();
      this.folder = folderPath.join("/");
    }
  }

  handleDialogResourceNodeClick(node: any): void {
    this.dialogSelectedNode = this.getTreeNode(node);
    this.setFolder(this.dialogSelectedNode);
    this.setDialogActiveResource(this.dialogSelectedNode);
    this.setLastSelected(this.dialogSelectedNode);
  }

  importResource(event: MouseEvent): void {
    this.openDialogWithId("uploadGenericResourcesDialog");
    let resource: resource | undefined = this.getActiveDialogResource();
    if (resource) {
      this.resourceView = resource.name;
      this.mimeType = resource.mimeType;
      this.activePath = resource.path;
      this.refreshDialogResources(this.fileWorkspaceService.activeResource.path || this.activePath, this.handleDialogResourceNodeClick({
        type: this.fileWorkspaceService.activeResource.type || "folder",
        name: this.fileWorkspaceService.activeResource.name || this.resourceView,
        path: this.fileWorkspaceService.activeResource.path || this.activePath,
      }));
    }
  }

  changeActiveResource(resource: resource): void {
    if(resource.name !== 'icons' && this.showUploadFont){
      this.showUploadFont = false
    }
    this.dialogProjectResourcesTree = [];
    for (let resourceItem of this.resources) {
      if (resourceItem.name === resource.name) {
        resourceItem.isActive = true;
        this.resourceView = resourceItem.name;
        this.activePath = resourceItem.path;
        this.mimeType = resourceItem.mimeType;
        let resourceLastSelected: Partial<activeResource> | undefined = resourceItem.lastSelected;
        this.refreshDialogResources(resourceLastSelected?.path || this.activePath, this.handleDialogResourceNodeClick({
          name: resourceLastSelected?.name || this.resourceView,
          type: resourceLastSelected?.type || "folder",
          path: resourceLastSelected?.path || this.activePath
        }));
      } else {
        resourceItem.isActive = false;
      }
    }
  }

  setUploadMessage(caption: string | null, type: string | null): void {
    this.uploadMessage.caption = caption;
    this.uploadMessage.type = type;
    if (type && type !== "loading") {
      this.wmsFileUpload.resetModel();
    }
  }

  setUploadMessageClass(messageType: string | null): void {
    switch (messageType) {
      case 'success':
        this.messageClass = 'alert-success';
        this.messageIconClass = 'wms wms-done';
        break;
      case 'error':
        this.messageClass = 'alert-danger';
        this.messageIconClass = 'wms wms-error-outline';
        break;
      case 'warning':
        this.messageClass = 'alert-warning';
        this.messageIconClass = 'wms wms-bell';
        break;
      case 'info':
        this.messageClass = 'alert-info';
        this.messageIconClass = 'wms wms-info';
        break;
      case 'loading':
        this.messageClass = 'alert-info alert-loading';
        this.messageIconClass = 'fa fa-spinner fa-spin';
        break;
    }
  }

  toggleMessage(msg: string | null, type: string | null): void {
    this.setUploadMessage(msg, type);
    this.setUploadMessageClass(type);
    this.disableDialogActions = (type === 'loading');
  }

  addFolder(newFolderName: any): void {
    this.toggleMessage(null, null);
    let folderRegEx: RegExp = /^[\w-]+(\/?[\w-])*$/;
    if (!newFolderName) {
      return;
    }
    if (!this.folder) {
      this.toggleMessage(this.locale["MESSAGE_ERROR_NO_FOLDER_SELECTED_DESC"], "error");
      return;
    }
    if (!folderRegEx.test(newFolderName)) {
      this.toggleMessage(this.locale["MESSAGE_FOLDERNAME_INVALID"], "error");
      return;
    }
    this.addingFolder = true;
    this.fileService.addDir(this.folder + "/" + newFolderName).then((): void => {
      this.addingFolder = false;
      this.ctrlScope.showAddFolderOption = false;
      this.newFolderName = "";

      this.refreshDialogResources(this.folder + "/" + newFolderName, this.handleDialogResourceNodeClick({
        name: newFolderName,
        path: this.folder + "/" + newFolderName,
        type: "folder"
      }));
      this.refreshResources(this.folder, this.handleResourceNodeClick({
        name: newFolderName,
        path: this.folder,
        type: "folder"
      }));
    }, (): void => {
      this.addingFolder = false;
      this.toggleMessage(this.locale["MESSAGE_ERROR_ADD_FOLDER"], 'error');
    });
  }

  onKeyPress(event: KeyboardEvent, newFolderName: any): void {
    event.preventDefault();
    if (event.key === "Enter") {
      this.addFolder(newFolderName);
    }
  }

  onAddFolderViewClose(): void {
    this.toggleMessage(null, null);
    this.ctrlScope.showAddFolderOption = false;
    this.newFolderName = '';
  }

  dialogDeleteIconClick(): void {
    if (deleteResourceRestricted(this.resourceView, this.dialogActiveResource.path)) {
      this.notificationService.show("error", this.locale["MESSAGE_ERROR_TITLE"], this.locale["MESSAGE_ERROR_DELETE_SELECT_RESOURCE"]);
      return;
    }
    if (this.dialogActiveResource.path.includes("i18n/" + this.fileWorkspaceService.project.defaultLanguage + ".json")) {
      this.notificationService.show("error", this.locale["MESSAGE_ERROR_TITLE"], this.locale["MESSAGE_ERROR_DELETE_DEFAULT_LANGUAGE_NOT_ALLOWED"]);
      return;
    }
    this.toggleMessage(null, null);
    this.openDialogWithId('dialogDeleteResourceModal');
  }

  deleteResource(): void {
    this.fileService.remove(this.dialogActiveResource.path).then((): void => {
      this.closeDialogWithId('dialogDeleteResourceModal');
      this.notificationService.show("success", this.locale["MESSAGE_SUCCESS_TITLE"], this.locale["MESSAGE_SUCCESS_DELETE_FILE_DESC"]);
      let resourceItem: resource | undefined = this.getActiveDialogResource();
      if (resourceItem) {
        resourceItem.lastSelected = undefined;
      }
      this.removeResourcesFromState(this.dialogSelectedNode.path);
      this.folder = this.dialogSelectedNode.path.substring(0, this.dialogSelectedNode.path.lastIndexOf('/'));
      this.refreshDialogResources(this.folder, this.handleDialogResourceNodeClick({
        name: this.resourceView,
        type: "folder",
        path: this.folder
      }));
      let lastActiveResource: activeResource = this.getLastActiveResourceFromState();
      this.removeLastActiveResourceFromState();
      this.refreshResources(lastActiveResource.path, this.handleResourceNodeClick(lastActiveResource));
    });

    if (this.resourceView === 'icons') {
      const selectedNode = this.dialogActiveResource.name;

      this.fileService.read('resources/icons/designer.js').then((result) => {
        result = result.replace('export default ', '');
        result = JSON.parse(result);
        delete result[selectedNode];
        if (!isEmpty(result)) {
          this.fileService.write('resources/icons/designer.js', 'export default ' + JSON.stringify(result))
        } else {
          this.fileService.remove('resources/icons/designer.js');
        }
      });

      this.fileService.read('font.config.js').then((result) => {
        var searchString = '"name":"' + selectedNode + '"';
        var regex = new RegExp(`{[^}]*${searchString}[^}]*},`);
        var matchingObjects = result.match(regex);
        result = result.replace(matchingObjects, '');
        this.fileService.write('font.config.js', result);
      });
    }
  }

  updateWorkspaceOnUploadSuccess(response: any, selectedFiles: FileList): void {

    //TODO emit upload events, execute application level callbacks

    let lastSelectedFileName: string = selectedFiles[0].name;
    let msgType: string = "success";
    let successMsg: string | undefined = this.getMessage(msgType);
    if (successMsg) {
      this.toggleMessage(this.locale[successMsg], msgType);
      this.notificationService.show("success", this.locale["MESSAGE_SUCCESS_TITLE"], this.locale[successMsg]);
    } else {
      let successMsgWithFileCount: string = (selectedFiles.length > 1) ? (selectedFiles.length + " files " + this.locale["MESSAGE_SUCCESS_IMPORT"]) : this.locale["MESSAGE_SUCCESS_IMPORT"];
      this.toggleMessage(successMsgWithFileCount, msgType);
      this.notificationService.show("success", this.locale["MESSAGE_SUCCESS_TITLE"], successMsgWithFileCount);
    }
    this.spinnerService.hide();
    this.refreshDialogResources(this.folder + "/" + lastSelectedFileName, this.handleDialogResourceNodeClick({
      name: lastSelectedFileName,
      path: (this.folder + "/" + lastSelectedFileName),
      type: "file"
    }));
    let $treeEl = $('.resources-panel > .resources-tree').find('.wm-tree'),
      node = $treeEl.find('.active-tree-element'),
      _details   = node.data('details');
    if (_details.type !== 'folder') {
      const parentId = node.attr('parent');
      const parentNode = $treeEl.find('[data-identifier =' + parentId + ']');
      _details   = parentNode.data('details');
    }
    this.refreshResources(this.folder + "/" + lastSelectedFileName, this.handleResourceNodeClick({
      name: lastSelectedFileName,
      path: (this.folder + "/" + lastSelectedFileName),
      type: "file",
      relativePath: _details.relativePath + "/" + lastSelectedFileName
    }));
  }

  getMessage(type: string): string | undefined {
    let resource: resource | undefined = this.getActiveDialogResource();
    if (!resource) {
      return undefined;
    }
    if (type === "success") {
      return resource.successMsg;
    } else if (type === "error") {
      return resource.errorMsg;
    }
    return undefined;
  }

  handleUpload(uploadConfig: any, selectedFiles: FileList): void {
    this.toggleMessage(this.locale["MESSAGE_IMPORT_RESOURCE"], "loading");
    this.spinnerService.show(undefined);
    let actionService: any;
    if (this.resourceView === "prefabs") {
      actionService = this.prefabService;
    } else if (this.resourceView === "themes") {
      actionService = this.themeService;
    } else if (this.resourceView === "templatebundles") {
      actionService = this.pageTemplatesService;
    } else if (this.resourceView === "connectors") {
      actionService = this.connectorService;
    } else {
      actionService = this.fileService;
    }
    actionService.upload(uploadConfig).then((response: any): void => {
      this.updateWorkspaceOnUploadSuccess(response, selectedFiles);
    }, (response: any): void => {
      let msgType: string = "error";
      let errorMsg: string | undefined = this.getMessage(msgType) || this.locale["MESSAGE_ERROR_IMPORT_GENERIC"];
      if (errorMsg) {
        this.toggleMessage(this.locale[errorMsg], msgType);
        this.notificationService.show("error", this.locale["MESSAGE_ERROR_TITLE"], this.locale[errorMsg]);
      }
    });
  }

  getUploadConfig(selectedFiles: FileList): any {
    let formData: FormData = new FormData();
    if (selectedFiles.length > 1) {
      for (let k: number = 0; k < selectedFiles.length; k++) {
        formData.append("file" + k, selectedFiles[k]);
      }
    } else {
      formData.append("file", selectedFiles[0]);
    }
    return {
      action: 'upload',
      path: this.folder,
      content: formData
    };
  }

  validateResource(selectedFiles: FileList): boolean {
    let restrictedPaths: string[] = [
      '../lib/project-external-dependency-jars',
      '../project/lib/project-external-dependency-jars',
      '../project/generated-angular-app'
    ];
    let isRestrictedPath: string | undefined = restrictedPaths.find((restrictedPath: string) => {
      return this.folder.startsWith(restrictedPath);
    });
    if (isRestrictedPath) {
      this.notificationService.show("error", this.locale["MESSAGE_ERROR_TITLE"], this.locale["MESSAGE_ERROR_UPLOAD_NOT_ALLOWED"]);
      this.wmsFileUpload.resetModel();
      return false;
    }
    if (selectedFiles.length === 0) {
      this.toggleMessage(this.locale["MESSAGE_ERROR_NO_FILE_SELECTED_DESC"], "error");
      return false;
    }
    for (let i: number = 0; i < selectedFiles.length; i++) {
      let fileName: string | undefined = selectedFiles[i]?.name;
      if (!fileName) {
        this.toggleMessage(this.locale["MESSAGE_ERROR_NO_FILE_OR_FOLDER_SELECTED_DESC"], "error");
        return false;
      }
      if (this.resourceView === "prefabs" || this.resourceView === "themes" || this.resourceView === "templatebundles") {
        if (!isZipFile(selectedFiles[i])) {
          this.toggleMessage(this.locale["MESSAGE_ERROR_ZIP_INVALID_FILE"], "error");
          return false;
        }
        let fileName: string = selectedFiles[i].name;
        let newFileName: string = fileName.substring(0, (fileName.length - 4));
        if (newFileName && !this.projectService.validateName(newFileName)) {
          this.toggleMessage(this.locale["MESSAGE_ERROR_PREFAB_NAME_INVALID_DESC"], "error");
          return false;
        }
      }
      else if (this.resourceView === "audio") {
        if (!isAudioFile(selectedFiles[i].name)) {
          this.toggleMessage(this.locale["MESSAGE_ERROR_AUDIO_IMPORT_DESC"], "error");
          return false;
        }
      }
      else if (this.resourceView === "video") {
        if (!isVideoFile(selectedFiles[i].name)) {
          this.toggleMessage(this.locale["MESSAGE_ERROR_VIDEO_IMPORT_DESC"], "error");
          return false;
        }
      }
      else if (this.resourceView === "image") {
        if (!isImageFile(selectedFiles[i].name)) {
          this.toggleMessage(this.locale["MESSAGE_ERROR_IMAGE_INVALID_FILE"], "error");
          return false;
        }
      }
      else if (this.resourceView === "connectors") {
        if (!isZipFile(selectedFiles[i].name)) {
          this.toggleMessage(this.locale["MESSAGE_ERROR_ZIP_INVALID_FILE"], "error");
          return false;
        }
      }
      else if (this.resourceView === "resources") {
        if (isExeFile(selectedFiles[i].name)) {
          this.toggleMessage(this.locale["MESSAGE_ERROR_UNSUPPORTED_RESOURCE_FILE"], "error");
          return false;
        }
      }
      else if (this.resourceView === "jar") {
        if (!isJarFile(selectedFiles[i].name)) {
          this.toggleMessage(this.locale["MESSAGE_ERROR_UNSUPPORTED_RESOURCE_FILE"], "error");
          return false;
        }
      }
    }
    return true;
  }

  uploadResource(selectedFiles: FileList): void {
    if (this.validateResource(selectedFiles)) {
      let uploadConfig: any = this.getUploadConfig(selectedFiles);
      this.handleUpload(uploadConfig, selectedFiles);
    }
  }

  handleUploadFilesClick($event: Event): void {
    this.toggleMessage(null, null);
  }

  excludeSpecialCharactersFromFileName(selectedFileName: string): string {
    let fileName: string = "";
    let fileNameArrayWithExtension: string[] = selectedFileName.split(".");
    let fileExtension = fileNameArrayWithExtension.pop();
    if (fileExtension === "xz" || fileExtension === "gz") {
      let fileExt: string | undefined = fileNameArrayWithExtension.pop();
      if (fileExt) {
        fileExtension = fileExt.concat(".", fileExtension);
      }
    }
    let fileNameArray: string[] = fileNameArrayWithExtension;
    let fileNameWithoutSpecialCharacters = fileNameArray.join(".").replace(/[^\w.-]+/g, "_");
    if (fileExtension) {
      fileName = fileNameWithoutSpecialCharacters.concat(".", fileExtension);
    }
    return fileName;
  }

  getSelectedFile(model: any): void {
    if (model.type === "SUCCESS") {
      let selectedFiles: FileList = model.choosenFiles;
      let renamedSelectedFiles: DataTransfer = new DataTransfer();
      for (let y=0; y<selectedFiles.length; y++) {
        renamedSelectedFiles.items.add(new File([selectedFiles[y]], this.excludeSpecialCharactersFromFileName(selectedFiles[y].name), {type: selectedFiles[y].type}));
      }
      this.uploadResource(renamedSelectedFiles.files);
    }
  }

  handleDropView($event: boolean): void {
    this.showDropView = $event;
  }

  handleUploadDroppedFiles($event: FileList): void {
    this.uploadResource($event);
    this.showDropView = false;
  }

  setCursorPosition(data: any){
    this.editorComponent.setEditorFocus();
    this.editorComponent.setCursorPosition(data);
  }

  isFileReadOnly(path: string) {
    if (!path) {
      return false;
    }
    return  readOnlyFiles.some((el: string) => {
      return path.indexOf(el) !== -1;
    });
  }

  // To set the readonly mode for the selected file.
  handleReadonlyForWSFile(path: string) {
    let isFileReadonly = this.isFileReadOnly(path);
    this.editorComponent?.setReadonly(isFileReadonly);
    this.fileWorkspaceService.editorOptions.readOnly = isFileReadonly;
  }

  showUploadFontsOn(){
    this.showUploadFont = true;
  }
  goBacktoResource(){
    this.showUploadFont = false;
  }

  navigate(resource: string){
    this.router.navigate(['/settings/artifacts/prefabs/project-prefab']);
    this.artifactsService.selectedPrefabName = resource;
  }

  get displayPath(): string {
    const path = this.fileWorkspaceService.activeResource?.relativePath;
    return path?.startsWith('/') ? path.substring(1) : path || '';
  }

  navigateToFunction(fnName: string) {
    if(fnName === "") return;
    let newfnName = fnName.concat(" = function");
    setTimeout(async () => {
      const isEditorAvailable = await this.editorComponent.ensureMonacoEditorLoaded();
      if(isEditorAvailable) {
        let wmsEditor = this.editorComponent.wmsEditor;
        this.editorComponent.setEditorFocus();
        let wmsEditorModel: ITextModel | null = wmsEditor?.getModel();
        let position: FindMatch | null | undefined = wmsEditorModel?.findNextMatch(newfnName, { column: 1, lineNumber: 1 }, false, true, null, true);
        if (position?.matches?.length) {
          let lineNumber: number = position?.range.startLineNumber + 1;
          let editorPos: IPosition = {
            lineNumber: lineNumber || 1,
            column: 1
          };
          this.editorComponent.setEditorFocus();
          this.editorComponent.setCursorPosition(editorPos);

        } else {
          this.editorComponent.setEditorFocus();
          this.notificationService.show('info', '', 'Unable to navigate to selected method ' + fnName)
        }
      }
    })
  }
}
